import { axios, Response } from '..'

export interface UpdateTaskRequest {
  title: string
  description?: string
  startDate?: string
  endDate?: string
}

export const editTask = (
  taskId: string,
  request: UpdateTaskRequest
): Response<void> => {
  return axios.put(`/v1/tasks/${taskId}`, request)
}
